<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script lang="ts" setup>
  import { onMounted } from 'vue';
  import versionLogic from '@/business/versionLogic';
  import { useAuthStore } from './store/auth/authStore';


  onMounted(() => {
    const { addAppVersion, initApiVersion } = versionLogic();
    addAppVersion();
    initApiVersion();
    const authStore = useAuthStore();
    authStore.initializeAuthFromStorage();
  });
</script>
